import {
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";

const AcceptPopup = ({
  openAccept,
  onClose,
  handleAdminAccept,
  selectedAlertId,
  workerList,
  description: initialDescription,
  setSearch
}) => {
  const [selectedWorker, setSelectedWorker] = useState("");
  const [bookingDate, setBookingDate] = useState(null);
  const [bookingTime, setBookingTime] = useState(null);
  const [description, setDescription] = useState(initialDescription || "");


  useEffect(() => {
    setDescription(initialDescription || "");
  }, [initialDescription]);

  const handleWorkerChange = (newValue) => {
    if (newValue) {
      setSelectedWorker(newValue.id);
      setSearch(newValue.worker_name);
    } else {
      setSelectedWorker("");
      setSearch("");
    }
  };
  

  const handleDateChange = (newDate) => {
    setBookingDate(newDate);
  };

  const handleTimeChange = (newTime) => {
    setBookingTime(newTime);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  return (
    <Dialog
      open={openAccept}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <DialogTitle style={{ color: "#ff4d4d" }}>
          Do you really want to accept?
        </DialogTitle>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Booking Date"
            value={bookingDate}
            onChange={handleDateChange}
            shouldDisableDate={(date) => date.isBefore(new Date(), "day")}
            format="DD-MM-YYYY"
            slotProps={{
              textField: {
                error: false,
              },
            }}
            sx={{ width: "100%", marginTop: "7px" }}
          />
          <TimePicker
            label="Booking Time"
            value={bookingTime}
            onChange={handleTimeChange}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            sx={{ width: "100%", marginTop: "7px" }}
          />
        </LocalizationProvider>
        <TextField
          fullWidth
          label="Booking Description"
          name="description"
          margin="dense"
          value={description}
          onChange={handleDescriptionChange}
          multiline
          rows={3}
        />
       
<FormControl fullWidth style={{ margin: "7px 0" }}>
  <Autocomplete
    options={workerList || []}
    getOptionLabel={(option) => option ? `${option.worker_name} - ${option.mobile_number}` : ""}
    value={workerList.find((worker) => worker.id === selectedWorker) || null}
    onChange={(event, newValue) => handleWorkerChange(newValue)}

    isOptionEqualToValue={(option, value) => option.id === value.id}
    renderInput={(params) => <TextField {...params} label="Select Worker" />}
  />
</FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (selectedWorker && bookingDate && bookingTime) {
              const combinedDateTime = bookingDate
                .hour(bookingTime.hour())
                .minute(bookingTime.minute())
                .second(0)
                .millisecond(0);

              const booked_at = combinedDateTime.toISOString();
              handleAdminAccept(selectedAlertId, selectedWorker, "Accepted", {
                booked_at,
                description,
              });
              onClose();
            } else {
              alert("Please fill all fields.");
            }
          }}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Accept
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          color="success"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptPopup;
